import React from "react";
import { Updater, useImmer } from "use-immer";

import { IgButton, IgTextField, IgTypography } from "@intelligems/ig-theme";
import { CouponType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useFetchCoupon } from "@src/api/stripe/get-coupon";

interface CouponSectionProps {
  coupon: CouponType | null;
  setCoupon: Updater<CouponType | null>;
}
export const CouponSection = ({ coupon, setCoupon }: CouponSectionProps) => {
  const [value, setValue] = useImmer<string>("");
  const fetchCoupon = useFetchCoupon();
  const theme = useTheme();

  if (coupon) {
    return (
      <Grid container item justifyContent={"center"}>
        <IgTypography color={theme.palette.text.tonal.success}>
          {coupon?.percentOff
            ? `${coupon.percentOff}%`
            : coupon?.amountOff
              ? `${coupon.amountOff / 100}`
              : ""}{" "}
          Off Applied!
        </IgTypography>
      </Grid>
    );
  }

  return (
    <Grid container item>
      <Grid
        container
        item
        justifyContent={"center"}
        alignItems={"end"}
        columnSpacing={1}
      >
        <Grid>
          <IgTextField
            disabled={fetchCoupon.isPending}
            value={value}
            size="small"
            label={"Add Coupon"}
            onChange={(e) => setValue(e.target.value)}
          />
        </Grid>
        <Grid item>
          <IgButton
            loading={fetchCoupon.isPending}
            onClick={() => {
              fetchCoupon.mutate(value, {
                onSuccess: (data) => {
                  if (data.coupon) {
                    setCoupon(data.coupon);
                  }
                },
              });
            }}
          >
            Add
          </IgButton>
        </Grid>
      </Grid>
    </Grid>
  );
};
